var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("header", { staticClass: "header header--protein" }, [
        _c("div", { staticClass: "header__container" }, [
          _c("div", { staticClass: "header__row" }, [
            _c("a", {
              staticClass: "prev prev--white",
              attrs: { href: "/myprotein-result", "aria-label": "이전" }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v("\n\t\t\t\t\t우리 몸 속 많은 역할을 하는"),
            _c("br"),
            _vm._v("\n\t\t\t\t\t‘단백질’\n\t\t\t\t")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c(
          "div",
          { staticClass: "contents__contents contents__contents--overlap" },
          [
            _c("p", { staticClass: "desc desc--secondary" }, [
              _vm._v(
                "\n\t\t\t\t\t단백질은 신체 조직, 피부, 머리카락, 호르몬, 뼈, 효소 등 우리 몸을 구성하고 몸 곳곳에 비타민 및 무기질 등 영양소를 운반해 주고 저장함으로써 "
              ),
              _c("span", { staticClass: "line-highlight" }, [
                _vm._v("인체가 발달하고 성장하는 것을 도와주는")
              ]),
              _vm._v(" 중요한 영양소입니다.\n\t\t\t\t")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("./assets/images/protein02.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "etc" }, [
              _vm._v(
                "\n\t\t\t\t\t*출처: Hoffman, Jay R., and Michael J. Falvo. “Protein-which is best?.” Journal of sports science & medicine 3.3 (2004): 118."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\t\t\tHashimoto A, Kambe T. Mg, Zn and Cu Transport Proteins: A Brief Overview from Physiological and Molecular Perspectives. J Nutr Sci Vitaminol (Tokyo). 2015;61 Suppl:S116-8."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\t\t\tReboul, E., & Borel, P. (2011). Proteins involved in uptake, intracellular transport and basolateral secretion of fat-soluble vitamins and carotenoids by mammalian enterocytes. Progress in lipid research, 50(4), 388-402.\n\t\t\t\t"
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa6e918c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa6e918c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinInfo02.vue
// module id = neLy
// module chunks = 0